import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import EmployeeInfoModal from "./Components/employee-info-modal";
import axios from "axios";
import {toast} from "react-toastify";
import {
    setPayrollPermitsReportRequestData,
    setPayrollPermitsReportResponseData
} from "../../../../_reducers/DataPanel/Payroll/payrollSlice";
import Input from "../../../common/Input";
import Pagination from "../../../primer/Pagination";
import Alert from "react-bootstrap/Alert";
import {permitTypes} from "./Components/constants";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import Dropdown from "../../../primer/Dropdown";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import * as XLSX from "xlsx";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import ReportsTemplate from "../../../common/ReportsTemplate";
import BetterCheckBox from "../../../common/BetterCheckBox";

const WorkPermitReport = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const requestData = useSelector((state) => state.PAYROLL.employeesPermitsReportRequestData);
    const responseData = useSelector((state) => state.PAYROLL.employeesPermitsReportResponseData);

    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);

    // Employee Modal
    const [showEmployeeInfoModal, setShowEmployeeInfoModal] = useState(false);
    const [employeeInfoModalId, setEmployeeInfoModalId] = useState("");

    useEffect(() => {
        const prepChange = {};
        if (isEmpty(requestData.date_from)) prepChange.date_from = moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY");
        if (isEmpty(requestData.date_to)) prepChange.date_to = moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY");
        if (Object.keys(prepChange).length > 0) {
            dispatch(setPayrollPermitsReportRequestData({...requestData, ...prepChange}));
        }
    }, [])

    const typeOptions = [
        {value: "yearly", label: "Ετήσια Αποτέλεσματα"},
        {value: "by_protocol", label: "Ανάλυση ανά υποβολή"}
    ]

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged])

    const fetchReport = (fromPagination = false) => {
        const prepReq = {...requestData};
        if (isEmpty(prepReq.date_from)) prepReq.date_from = moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY");
        if (isEmpty(prepReq.date_to)) prepReq.date_to = moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY");

        if (!fromPagination) {
            prepReq.page = 1;
            dispatch(setPayrollPermitsReportRequestData(prepReq));
        }
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/payroll/fetch-work-permit-report`, {
            ...prepReq,
            company: company.id,
            year: company.year,
        }).then((res) => {
            const resData = res.data;
            if (res.data.status === "200") {
                if (!fromPagination) {
                    toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
                }
                dispatch(setPayrollPermitsReportResponseData({...resData, totalPages: resData.totalPages, data: resData.data, type: resData.type}));
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        let prepReq = {};
        if (type === "input") {
            prepReq[name] = e.target.value;
        } else if (type === "checkbox") {
            prepReq[name] = e.target.checked;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepReq[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepReq[name] = "";
            }
        } else if (type === "dropdown") {
            prepReq[name] = e.value;
        } else if (type === "cb") {
            prepReq[name] = e.target.checked;
        } else if (type === "msdd") {
            prepReq[name] = e.flatMap((o) => o.value);
        }
        dispatch(setPayrollPermitsReportRequestData({...requestData, ...prepReq}));
    }

    const handlePageChange = (num) => {
        setPageChanged(true);
        dispatch(setPayrollPermitsReportRequestData({...requestData, page: num}));
    }

    const thickBorderStyle = "2px solid #76aeb7";

    const aroundStyle = {
        borderTop: thickBorderStyle,
        borderBottom: thickBorderStyle
    }

    const handlePDFExport = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL2}/payroll/fetch-work-permit-report`, {
                ...requestData,
                page: -1,
                type: responseData.type,
                company: company.id,
                year: company.year,
            });
            if (res.data.status === "200") {
                const doc = new jsPDF('landscape');
                let y = 23;
                doc.addFileToVFS("arialuni.ttf", liberationSerif);
                doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                doc.setFont("DejaVu Sans Bold");
                doc.setFontSize(12);
                const header = doc.splitTextToSize(`Άδειες Εργαζομένων`, 200);
                const headerString = header.join("\n");
                doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
                doc.setFont("DejaVu Sans Normal");
                doc.setFontSize(9);
                doc.text(`${company.name}, ΑΦΜ: ${company.vatNumber}`, 15, 17, {alignment: "center"});
                doc.text(`ΔΟΥ: ${companyDetails.doy}`, 15, 21, {alignment: "center"});
                doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY")}`, 190, 21, {alignment: "center"});
                const imgData = 'assets/images/prrimer-logo.png';
                const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                const imgY = 3; // adjust the position as needed
                doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                doc.setFont("DejaVu Sans Normal");

                let columns;
                const rowData = [];
                if (responseData.type === "by_protocol") {
                    columns = [
                        "Αρ. Υποβολής",
                        "Εργαζόμενος",
                        "Ημερομηνία από",
                        "Ημερομηνία έως",
                        "Τύπος Αδείας",
                        "Πλήθος ημερών κανονικών αδειών",
                        "Υπόλοιπο κανονικών αδειών",
                        "Πλήθος ημερών λοιπών αδειών",
                        "Τρέχων σύνολο λοιπών αδειών"
                    ]
                    for (const row of res.data.data) {
                        row["employees"]?.forEach((emp, idx2) => {
                            rowData.push([
                                idx2 === 0 ? row["erganiProtocol"] : ">>",
                                String(emp["employeeIdentifier"]).split("|").join(" "),
                                emp["dateFrom"],
                                emp["dateTo"],
                                permitTypes.find((el) => el.value === emp["permitType"])?.label || emp["permitType"],
                                emp["diffNormal"],
                                emp["limitNormal"] - emp["balanceNormal"],
                                emp["diffNotNormal"],
                                emp["balanceNotNormal"],
                            ])
                        })
                    }
                } else {
                    columns = [
                        "Εργαζόμενος",
                        "Ληφθείσες Κανονικές Άδειες",
                        "Όριο Κανονικών Αδειών",
                        "Υπόλοιπο Κανονικών Αδειών",
                        "Λοιπές Ληφθείσες Άδειες",
                    ]
                    for (const row of res.data.data) {
                        rowData.push([
                            row["employeeIdentifier"],
                            row["takenNormalPermits"],
                            row["totalNormalPermits"],
                            row["remainingNormalPermits"],
                            row["otherPermits"],
                        ])
                    }
                }
                autoTable(doc, {
                    startY: y,
                    head: [columns],
                    body: rowData,
                    rowPageBreak: "avoid",
                    styles: {
                        font: "DejaVu Sans Normal",
                        fontStyle: "normal",
                        fontSize: 8, // set font size
                        halign: "center", // set alignment
                    },
                })
                const pageCount = doc.getNumberOfPages();
                // Add the pagination to each page
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                }
                doc.save("Άδειες Εργαζομένων.pdf");
            } else {
                toast.error(res.data.message);
            }
        } catch (axiosError) {
            console.log(axiosError);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }
    }

    const handleExcelExport = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL2}/payroll/fetch-work-permit-report`, {
                ...requestData,
                page: -1,
                type: responseData.type,
                company: company.id,
                year: company.year,
            });
            if (res.data.status === "200") {
                const rowData = [];
                if (responseData.type === "by_protocol") {
                    rowData.push([
                        "Αρ. Υποβολής",
                        "Εργαζόμενος",
                        "Ημερομηνία από",
                        "Ημερομηνία έως",
                        "Τύπος Αδείας",
                        "Πλήθος ημερών κανονικών αδειών",
                        "Υπόλοιπο κανονικών αδειών",
                        "Πλήθος ημερών λοιπών αδειών",
                        "Τρέχων σύνολο λοιπών αδειών"
                    ])
                    for (const row of res.data.data) {
                        row["employees"]?.forEach((emp, idx2) => {
                            rowData.push([
                                idx2 === 0 ? row["erganiProtocol"] : ">>",
                                String(emp["employeeIdentifier"]).split("|").join(" "),
                                emp["dateFrom"],
                                emp["dateTo"],
                                permitTypes.find((el) => el.value === emp["permitType"])?.label || emp["permitType"],
                                emp["diffNormal"],
                                emp["limitNormal"] - emp["balanceNormal"],
                                emp["diffNotNormal"],
                                emp["balanceNotNormal"],
                            ])
                        })
                    }
                } else {
                    rowData.push([
                        "Εργαζόμενος",
                        "Ληφθείσες Κανονικές Άδειες",
                        "Όριο Κανονικών Αδειών",
                        "Υπόλοιπο Κανονικών Αδειών",
                        "Λοιπές Ληφθείσες Άδειες",
                    ])
                    for (const row of res.data.data) {
                        rowData.push([
                            row["employeeIdentifier"],
                            row["takenNormalPermits"],
                            row["totalNormalPermits"],
                            row["remainingNormalPermits"],
                            row["otherPermits"],
                        ])
                    }
                }
                const workSheet = XLSX.utils.aoa_to_sheet(rowData);
                const workBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, "Άδειες Εργαζομένων");
                XLSX.writeFile(workBook, 'Άδειες Εργαζομένων.xlsx');
            } else {
                toast.error(res.data.message);
            }
        } catch (axiosError) {
            console.log(axiosError);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }
    }

    return (
        <React.Fragment>
            <ReportsTemplate
                templateType={"work-permit-report"}
                requestData={requestData}
                fetchReport={() => fetchReport(false)}
                setRequestData={(data) => {
                    dispatch(setPayrollPermitsReportRequestData({...requestData, ...data}));
                }}
                header={"Ανάλυση Αδειών Εργαζομένων"}
            />
            <Alert variant={"secondary"}>
                Η αναφορά δεν αντλεί δεδομένα από το Π.Σ. Εργάνη. Φαίρνει αποτελέσματα μόνο από τις άδειες που έχουν καταχωρηθεί στο σύστημα
                είτε από άντληση αδειών (που γίνεται από τις ρυθμίσεις) ή από την διαβίβασή τους.
            </Alert>
            <Row className={"mb-2"} onKeyDown={(e) => {
                if (e?.key === "Enter") fetchReport(false);
            }}>
                <Col md={2}>
                    <Dropdown
                        name={"type"}
                        label={"Τύπος Προβολής"}
                        options={typeOptions}
                        defaultValue={typeOptions.find((el) => el.value === requestData.type)}
                        key={requestData.value}
                        onChange={(e) => handleOnChange(e, "dropdown", "type")}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"employeeIdentifier"}
                        label={"Εργαζόμενος"}
                        value={requestData.employeeIdentifier}
                        placeholder={"Εισαγάγετε Όνομα/Επώνυμο/ΑΦΜ"}
                        onChange={(e) => handleOnChange(e, "input", "employeeIdentifier")}
                    />
                </Col>
                {requestData.type === "by_protocol" && (
                    <React.Fragment>
                        <Col md={2}>
                            <DateHelper
                                dateFromAndToFunction={(from, to) => dispatch(setPayrollPermitsReportRequestData({...requestData, date_from: from, date_to: to}))}
                            />
                        </Col>
                        <Col md={2}>
                            <DateBox
                                name="date_from"
                                selected={isEmpty(requestData.date_from) ? null : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                                label={"Ημερομηνία από"}
                                onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                            />
                        </Col>
                        <Col md={2}>
                            <DateBox
                                name="date_to"
                                selected={isEmpty(requestData.date_to) ? null : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                                label={"Ημερομηνία έως"}
                                onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                            />
                        </Col>
                    </React.Fragment>
                )}
            </Row>
            <Row>
                <Col md={2}>
                    <div style={{marginTop: "22px"}}>
                        <BetterCheckBox
                            name={"showInactiveEmployees"}
                            text={"Συμπερίληψη ανενεργών εργαζομένων"}
                            checked={requestData.showInactiveEmployees}
                            onChange={(e) => handleOnChange(e, "cb", "showInactiveEmployees")}
                        />
                    </div>
                </Col>
                <Col md={4}>
                    {requestData.type === "by_protocol" && (
                        <Dropdown
                            name={"workPermitTypes"}
                            multiSelect={true}
                            label={"Τύποι Αδειών"}
                            key={requestData.workPermitTypes.length}
                            defaultValue={permitTypes.filter((el) => requestData.workPermitTypes.includes(el.value))}
                            options={permitTypes}
                            onChange={(e) => handleOnChange(e, "msdd", "workPermitTypes")}
                        />
                    )}
                </Col>
                <Col md={6} className={"justify-content-end"}>
                    <Button onClick={() => fetchReport()} className="btn btn-primary float-right" disabled={loading} style={{marginTop: "23px"}}>
                        Εφαρμογή φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Col>
            </Row>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <Row className={"mt-2"}>
                        <Col md={7}>
                            <div className={"text-muted mt-2"}><i>Για περισσότερες λεπτομέριες μπορείτε να πατήσετε πάνω στον εργαζόμενο, ανοίγοντας ένα παράθυρο με περαιτέρω ανάλυση αδειών.</i></div>
                        </Col>
                        <Col md={5} className={"d-flex justify-content-end"}>
                            <Pagination
                                currentPage={requestData.page}
                                totalPages={responseData.totalPages}
                                handlePageChange={(num) => handlePageChange(num)}
                            />
                        </Col>
                    </Row>
                    {responseData.type === "by_protocol" ? (
                        <React.Fragment>
                            <Row>
                                <Col md={12}>
                                    <table className={"simpleClassicTable simpleClassicTableGrayHover"}>
                                        <colgroup>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "7.5%", ...aroundStyle, borderLeft: thickBorderStyle}}></col>
                                            <col span={1} style={{width: "7.5%", ...aroundStyle, borderRight: thickBorderStyle}}></col>
                                            <col span={1} style={{width: "7.5%", ...aroundStyle, borderLeft: thickBorderStyle}}></col>
                                            <col span={1} style={{width: "7.5%", ...aroundStyle, borderRight: thickBorderStyle}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Αρ. Υποβολής</th>
                                            <th>Εργαζόμενος</th>
                                            <th>Ημερομηνία από</th>
                                            <th>Ημερομηνία έως</th>
                                            <th>Τύπος Αδείας</th>
                                            <th>Πλήθος ημερών κανονικών αδειών</th>
                                            <th>Υπόλοιπο κανονικών αδειών</th>
                                            <th>Πλήθος ημερών λοιπών αδειών</th>
                                            <th>Τρέχων σύνολο λοιπών αδειών</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {responseData.data.map((row, idx) => (
                                            <React.Fragment>
                                                {row["employees"].map((emp, idx2) => (
                                                    <React.Fragment>
                                                        <tr key={`rep-${idx}-${idx2}`}>
                                                            <td>{idx2 === 0 ? row["erganiProtocol"] : ">>"}</td>
                                                            <td>
                                                                <span style={{cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dotted"}} onClick={() => {
                                                                    if (emp.employeeId) {
                                                                        setEmployeeInfoModalId(emp.employeeId);
                                                                        setShowEmployeeInfoModal(true);
                                                                    }
                                                                }}>
                                                                    {String(emp["employeeIdentifier"]).split("|").join(" ")}
                                                                </span>
                                                            </td>
                                                            <td>{emp["dateFrom"]}</td>
                                                            <td>{emp["dateTo"]}</td>
                                                            <td>{permitTypes.find((el) => el.value === emp["permitType"])?.label || emp["permitType"]}</td>
                                                            <td>{emp["diffNormal"]}</td>
                                                            <td>{emp["limitNormal"] - emp["balanceNormal"]}</td>
                                                            <td>{emp["diffNotNormal"]}</td>
                                                            <td>{emp["balanceNotNormal"]}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Row className={"mt-2"}>
                                <Col md={12}>
                                    <table className={"simpleClassicTable simpleClassicTableGrayHover"}>
                                        <colgroup>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "15%", ...aroundStyle, borderLeft: thickBorderStyle}}></col>
                                            <col span={1} style={{width: "15%", ...aroundStyle}}></col>
                                            <col span={1} style={{width: "15%", ...aroundStyle, borderRight: thickBorderStyle}}></col>
                                            <col span={1} style={{width: "15%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Εργαζόμενος</th>
                                            <th>Ληφθείσες Κανονικές Άδειες</th>
                                            <th>Όριο Κανονικών Αδειών</th>
                                            <th>Υπόλοιπο Κανονικών Αδειών</th>
                                            <th>Λοιπές Ληφθείσες Άδειες</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {responseData.data.map((row, idx) => (
                                            <tr key={`rep-${idx}`}>
                                                <td>
                                                    <span style={{cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dotted"}} onClick={() => {
                                                        if (row.employeeId) {
                                                            setEmployeeInfoModalId(row.employeeId);
                                                            setShowEmployeeInfoModal(true);
                                                        }
                                                    }}>
                                                        {row["employeeIdentifier"]}
                                                    </span>
                                                </td>
                                                <td>{row["takenNormalPermits"]}</td>
                                                <td>{row["totalNormalPermits"]}</td>
                                                <td>{row["remainingNormalPermits"]}</td>
                                                <td>{row["otherPermits"]}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                    <Row>
                        <BootstrapDropdown className="mb-3 mt-3">
                            <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic">
                                Αποθήκευση αποτελεσμάτων
                            </BootstrapDropdown.Toggle>
                            <BootstrapDropdown.Menu>
                                <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                    Αποθήκευση ως PDF
                                </BootstrapDropdown.Item>
                                <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                    Αποθήκευση ως XLSX
                                </BootstrapDropdown.Item>
                            </BootstrapDropdown.Menu>
                        </BootstrapDropdown>
                    </Row>

                    <EmployeeInfoModal
                        employeeId={employeeInfoModalId}
                        show={showEmployeeInfoModal}
                        setShow={setShowEmployeeInfoModal}
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default WorkPermitReport;
